import { escapeRegexpString } from "$json/lib/escape.js";
import { bb } from "$json";
/* high-on-info-ng:
 *
 * Make an information source from text in questions that matches the
 * description of an informationsource.
 *
 * Author: Niels Giesen
 * Copyright (C) 2011, 2012, 2015, 2016 by Berkeley Bridge
 *
 *
 */

(function ($) {
  function maybeEncodeURI(uri) {
    return uri.indexOf("%") > -1 ? uri : encodeURI(uri);
  }

  function replaceMatchWithHTML(n, from, to) {
    if (typeof n == "undefined") return false;
    if (n.tagName === "A" /*Do not mess with links*/) return false;
    if (n.nodeType == 3 /*Node.TEXT_NODE*/) {
      if (n.data.match(from)) {
        var nn = document.createElement("span");
        $(nn).html(n.data.replace(from, to));
        n.parentNode.replaceChild(nn, n);
        return true;
      }
      return false;
    } else {
      var kids = n.childNodes;
      for (var i = 0, len = kids.length; i < len; i++) {
        if (replaceMatchWithHTML(kids[i], from, to)) return true;
      }
      return false;
    }
  }

  function makeLinksInMainText(informationsources) {
    var source,
      from,
      to,
      content,
      isurl,
      object = $(".group.selected").get(0),
      flags = "m";
    for (var i = 0, len = informationsources.length; i < len; i++) {
      source = informationsources[i];
      if (!source.selected) continue;
      // eslint-disable-next-line security/detect-non-literal-regexp -- escaped
      from = new RegExp(
        "((?= )|^|\\b)" +
          escapeRegexpString(source.description) +
          "(\\b|$|(?= ))",
        flags
      );
      to = bb.escapeHTML(source.description);
      content = source.content;
      isurl = source.isurl;
      if (isurl) {
        replaceMatchWithHTML(
          object,
          from,
          "<a" +
            ' href="' +
            maybeEncodeURI(content) +
            '"' +
            ' target="_blank">' +
            to +
            "</a>"
        );
      } else {
        replaceMatchWithHTML(
          object,
          from,
          '<a class="p-high-on-info-ng-link"' +
            ' href="#Informatiebronnen">' +
            to +
            "</a>"
        );
      }
    }
  }

  $(document).on("bb:postHandleData", function (event, data) {
    if (data && data.informationsources) {
      var sources = $.grep(data.informationsources, function (source) {
        return (
          $.trim(source.description) != "" &&
          $.trim(source.content) != "" &&
          $.trim(source.content) != "http://"
        );
      });
      makeLinksInMainText(sources);
    }
  });
})(jQuery);
